export const primaryColor = "#232331";
export const secondaryColor = "#EC1D23";
export const buttonColor = "#EC1D23";
export const buttonHoverColor = "red";
export const lightgreyColor="lightgrey";
export const fontFamilyAll = 'Nunito Sans';
export const navLinkColor = 'white';
export const standardTextColor = 'black';
export const standardSubTextColor = 'grey';